import type { Role } from "@App/types/ayvens/role";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, type State } from "@App/state";
import { bindActionCreators } from "@reduxjs/toolkit";
import { setDriverData, setRole, setToken } from "@App/state/reducers/auth";

export const useVehicleSelector = () => {
  const initialRole = useSelector((state: State) => state.auth.initialRole);
  const initialToken = useSelector((state: State) => state.auth.initialToken);

  const dispatch = useDispatch();
  const {
    chooseService,
    choosePlace,
    chooseSlot,
    setMileage,
    setNumberPlate,
    setFirstName,
    setLastName,
    setEmail,
    setPhone,
    setMessage,
    setStreet,
    setNetwork,
    setCity,
    setPostcode,
    setAddition,
    setUserConfirmedAddress,
    clearPremiumServices,
  } = bindActionCreators(actionCreators, dispatch);

  const resetTokenAndDriverData = (role?: Role | null, keepNumberPlate?: boolean) => {
    clearPremiumServices();
    chooseService(null);
    choosePlace(null);
    chooseSlot(null);
    setMileage(null);
    setFirstName(null);
    setLastName(null);
    setEmail(null);
    setNetwork(null);
    setPhone({ country: "+49", number: null });
    setMessage("");
    setStreet("");
    setCity("");
    setPostcode("");
    setAddition("");
    setUserConfirmedAddress(false);
    dispatch(setRole(role ? role : (initialRole as Role)));
    dispatch(setToken(initialToken));
    dispatch(setDriverData(null));
    if (!keepNumberPlate) {
      setNumberPlate("");
    }
  };

  return {
    resetTokenAndDriverData,
  };
};
